// extracted by mini-css-extract-plugin
module.exports = {"spinner":"CircularProgress-module_spinner_1GQ73","rotation":"CircularProgress-module_rotation_BiFYm","sm":"CircularProgress-module_sm_18uhV"};